import { render } from "./IconBarcodeReader.vue?vue&type=template&id=24f0e41c"
import script from "./IconBarcodeReader.vue?vue&type=script&lang=ts"
export * from "./IconBarcodeReader.vue?vue&type=script&lang=ts"
script.render = render

export default script